import { FirebaseApp, initializeApp, getApps, getApp } from "firebase/app";
import { fetchAndActivate, getRemoteConfig, isSupported, RemoteConfig } from "firebase/remote-config";
import { firebaseConfig } from "../../firebase";
interface FireBaseAPIs {
  fetchFireBaseConfig: () => Promise<RemoteConfig>;
}
const REFETCH_INTERVAL = 300000; // 5min

const useFirebase = (): FireBaseAPIs => {
  // Check if Firebase app already exists, if not initialize it
  const app: FirebaseApp = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
  const fetchFireBaseConfig = async (): Promise<RemoteConfig> => {
    const rc = (await isSupported()) && getRemoteConfig(app);
    rc.defaultConfig = {};
    rc.settings.minimumFetchIntervalMillis = REFETCH_INTERVAL;
    const isActivated = await fetchAndActivate(rc); // downloads and makes remote variables available to the app
    if (isActivated) {
      console.log("Activated: ", isActivated);
    } else {
      console.log("May Be Already Activated: ", isActivated);
    }
    return rc;
  };
  return {
    fetchFireBaseConfig
  };
};
export default useFirebase;